import { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { pageIndicator } from "../apollo";
import {
  ComponentTabLink,
  ITabLink,
  ITabTitle,
  PageType,
} from "../components/component-tab";
import { AsideAdminComponent } from "../layout/aside-admin";
import { FormError2 } from "../components/form-error";
import { Button } from "../components/button";

import { useParams } from "react-router";
import {
  IEditCorporationFormProps,
  useEditCorporation,
} from "../hooks/useEditCorporation";
import { useGetCorporation } from "../hooks/useGetCorporation";
import {
  EditCorporationInput,
  EditCorporationMutation,
  GetCorporationInput,
  GetCorporationQuery,
} from "../generated/graphql";
import { useDaumPostcodePopup } from "react-daum-postcode";
import { useListLinkServiceSelect } from "../hooks/useListLinkServiceSelect";
import CreatableSelect from "react-select/creatable";
import { useListMainCategory } from "../hooks/useListMainCategory";
import { EditProductProps } from "../constants/enum";

export const AdminUpCorporationInfo:React.FC<EditProductProps> = ({
    tabs,
    setTabHandler,
}) => {
    const params = useParams();
    const [
      listLinkServiceSelect,
      { data: services },
    ] = useListLinkServiceSelect();
  
    const [listMainCategory, { data: mainCategory }] = useListMainCategory();
  
    useEffect(() => {
      pageIndicator("corporation");
    }, []);
  
    const {
      register,
      handleSubmit,
      getValues,
      setValue,
      setFocus,
      watch,
      control,
      formState: { errors, isValid },
    } = useForm<IEditCorporationFormProps>({ mode: "all" });
  
    const onGetComplete = (data: GetCorporationQuery) => {
      const {
        getCorporation: { ok, err, corporation },
      } = data;
      if (!ok) {
        alert("잘못된 접근입니다.");
        window.location.href = "/corporation";
        return;
      }
      setValue("address", corporation?.address);
      setValue("operationFrom", corporation?.operationFrom);
      setValue("operationTo", corporation?.operationTo);
      setValue("origin", corporation?.origin);
      setValue("name", String(corporation?.name));
      setValue("phone", corporation?.phone);
      setValue(`serviceId`, corporation?.linkService?.id);
      setValue("holiday", corporation?.holiday);
      setValue("deliveryLimitQuantity", corporation?.deliveryLimitQuantity);
      setValue(
        "mainCategory",
        corporation?.mainCategories?.map((category) => ({
          value: category.name,
          label: category.name,
        }))
      );
      setFocus("name");
    };
    const [getCorporation, { data, loading }] = useGetCorporation(onGetComplete);
    const getCorporationHandler = (corporationId: number) => {
      const getCorporationInput: GetCorporationInput = {
        corporationId,
      };
      getCorporation({ variables: { input: getCorporationInput } });
    };
  
    const onUpComplete = (data: EditCorporationMutation) => {
      const {
        editCorporation: { ok, err },
      } = data;
      if (ok) {
        alert("저장되었습니다.");
        setTabHandler(tabs + 1);
      } else {
        alert(err);
      }
    };
    const [
      editCorporation,
      { loading: editCorporationLoading },
    ] = useEditCorporation(onUpComplete);
  
    const onSubmit = () => {
      if (!params.corporationId) return;
      if (!editCorporationLoading) {
        const {
          name,
          address,
          phone,
          serviceId,
          mainCategory,
          operationFrom,
          operationTo,
          origin,
          holiday,
          deliveryLimitQuantity,
        } = getValues();
        let mainCategoryNames = [];
        if (mainCategory) {
          mainCategoryNames = mainCategory.map((category: any) => category.value);
        }
        const editCorporationInput: EditCorporationInput = {
          name,
          address,
          phone,
          corporationId: +params.corporationId,
          serviceId: serviceId ? +serviceId : 1,
          mainCategoryNames,
          operationFrom,
          operationTo,
          origin,
          holiday,
          deliveryLimitQuantity:
            deliveryLimitQuantity !== undefined &&
            deliveryLimitQuantity !== null &&
            !Number.isNaN(Number(deliveryLimitQuantity))
              ? Number(deliveryLimitQuantity)
              : null,
        };
        editCorporation({ variables: { input: editCorporationInput } });
      }
    };
  
    const tabList: ITabLink[] = [];
  
    const stitle: ITabTitle = { text: "거래처 편집" };
  
    const handlePostCode = (data: any) => {
      let fullAddress = data.address;
      let extraAddress = "";
  
      if (data.addressType === "R") {
        if (data.bname !== "") {
          extraAddress += data.bname;
        }
        if (data.buildingName !== "") {
          extraAddress +=
            extraAddress !== "" ? `, ${data.buildingName}` : data.buildingName;
        }
        fullAddress += extraAddress !== "" ? ` (${extraAddress})` : "";
      }
      setValue(`address`, fullAddress);
      setFocus(`address`);
    };
    const scriptUrl =
      "https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js";
    const open = useDaumPostcodePopup(scriptUrl);
    const handlerClick = () => {
      open({ onComplete: handlePostCode });
    };
  
    useEffect(() => {
      listLinkServiceSelect();
      listMainCategory();
    }, [listLinkServiceSelect, listMainCategory]);
    useEffect(() => {
      if (!params.corporationId) return;
      const corporationId = +params.corporationId;
      getCorporationHandler(corporationId);
    }, []);

  return (
    <div className="shadow-lg h-[800px] h-fix-content w-full overflow-auto bg-white">
  <form onSubmit={handleSubmit(onSubmit)}>
    <div className="pl-9 pr-11 py-8 space-y-4">
      <div className="space-y-2">
        <p className="font-bold text-[#4F4F4F] text-base">
          매장명
        </p>
        <input
          {...register("name", {
            required: `이름을 입력해주세요`,
          })}
          type="text"
          className="border w-full h-10 border-[#F0F0F4] text-base rounded-lg py-1 px-4"
        />
        {errors.name?.message && (
          <FormError2 errorMessage={errors.name.message} />
        )}
      </div>
      <div className="space-y-2">
        <p className="font-bold text-[#4F4F4F] text-base">
          번호
        </p>
        <input
          {...register("phone", {})}
          type="text"
          className="border w-full h-10 border-[#F0F0F4] text-base rounded-lg py-1 px-4"
        />
        {errors.phone?.message && (
          <FormError2 errorMessage={errors.phone.message} />
        )}
      </div>
      <div className="w-full grid grid-cols-2 gap-4">
                          <div className="space-y-2">
                            <p className="font-bold text-[#4F4F4F] text-base">
                              운영시간
                            </p>
                            <div className="flex flex-wrap items-center">
                    <input
                      {...register("operationFrom", {
                        required: `운영시간을 입력해주세요`,
                      })}
                      type="time"
                      className="border w-[calc(50%-12px)] h-10 border-[#F0F0F4] text-base rounded-lg py-1 px-4"
                    />
                    <div className="w-[24px] text-center">~</div>
                    <input
                      {...register("operationTo", {
                        required: `운영시간을 입력해주세요`,
                      })}
                      type="time"
                      className="border w-[calc(50%-12px)] h-10 border-[#F0F0F4] text-base rounded-lg py-1 px-4"
                    />
                  </div>
                  {errors.operationFrom?.message && (
                              <FormError2 errorMessage={errors.operationFrom.message} />
                            )}
                            {errors.operationTo?.message && (
                              <FormError2 errorMessage={errors.operationTo.message} />
                            )}
                          </div>
                          <div className="space-y-2 w-full">
                            <div className="space-y-2">
                              <p className="font-bold text-[#4F4F4F] text-base">
                                휴무일
                              </p>
                              <input
                                {...register("holiday", {})}
                                type="text"
                                className="border w-full h-10 border-[#F0F0F4] text-base rounded-lg py-1 px-4"
                              />
                            </div>
                          </div>
                          </div>
      <div className="space-y-2">
        <p className="font-bold text-[#4F4F4F] text-base">
          서비스 이름
        </p>
        <select
          {...register(`serviceId`, {
            required: "프로젝트 ID를 선택해주세요",
          })}
          className="border w-full border-[#F0F0F4] rounded-lg py-1 px-2"
        >
          {services?.listLinkServiceSelect.linkservice?.map(
            (service) => (
              <option
                key={`service-${service.id}`}
                value={service.id}
              >
                {service.name}
              </option>
            )
          )}
        </select>

        {errors.serviceId?.message && (
          <FormError2
            errorMessage={errors.serviceId.message}
          />
        )}
      </div>



      <div className="space-y-2">
        <p className="font-bold text-[#4F4F4F] text-base">
          <span className="pr-10">주소</span>
          <button
            className="py-2 px-4 border border-btnDarkLine rounded-lg text-btn text-grayFont"
            type="button"
            onClick={handlerClick}
          >
            우편번호찾기
          </button>
        </p>
        <div className="py-1">
          <input
            {...register("address", {})}
            type="text"
            className="border w-full h-10 border-[#F0F0F4] text-base rounded-lg py-1 px-4"
          />
          {errors.address?.message && (
            <FormError2
              errorMessage={errors.address.message}
            />
          )}
        </div>
      </div>
      <div className="space-y-2">
        <p className="font-bold text-[#4F4F4F] text-base">
          원산지
        </p>
        <input {...register("origin", {})} type="text" className="border w-full h-10 border-[#F0F0F4] text-base rounded-lg py-1 px-4" />
      </div>
      <div className="space-y-2">
        <p className="font-bold text-[#4F4F4F] text-base">
          배달 한도 수량
        </p>
        <input
          {...register("deliveryLimitQuantity", {
            valueAsNumber: true,
          })}
          type="number"
          min={0}
          placeholder="미입력 시 제한 없음"
          className="border w-full h-10 border-[#F0F0F4] text-base rounded-lg py-1 px-4"
        />
        <p className="text-xs text-[#8B8C8C]">
          한 번에 배송 가능한 수량입니다. 주문 수량이 이 수량을 초과할 때마다 배송비가 2,500원씩 추가됩니다. 비워두면 수량과 무관하게 기본 배송비(2,500원)만 부과됩니다.
        </p>
      </div>
      <div className="space-y-2">
        <p className="font-bold text-[#4F4F4F] text-base">
          업종 카테고리
        </p>
        <Controller
          name="mainCategory"
          control={control}
          render={({ field }) => (
            <CreatableSelect
              {...field}
              isClearable
              // 4. 다중 선택이 가능하도록 isMulti prop을 추가합니다.
              isMulti
              options={mainCategory?.listMainCategory?.mainCategories?.map(
                (category) => ({
                  value: category.name,
                  label: category.name,
                })
              )}
              placeholder="업종을 선택하거나 직접 입력하세요..."
              formatCreateLabel={(inputValue) =>
                `"${inputValue}" 새로 만들기`
              }
            />
          )}
        />
      </div>
      <div className="flex flex-wrap justify-center pt-6">
        <Button
          className={`w-[240px] h-[40px] bg-[#3D3E49] text-white rounded-lg`}
          canClick={true}
          actionText={`등록`}
          loading={loading}
          color={"text-white"}
        />
      </div>
    </div>
  </form>
</div>
);
};